import { defineMessages } from 'react-intl';

export default defineMessages({
    errorLoadingOperation: {
        id: 'ml.quoteandbind.common.MLHVQLandingPage.Error in loading operation',
        defaultMessage: 'Error in loading operation'
    },
    unableToLoad: {
        id: 'ml.quoteandbind.common.MLHVQLandingPage.Unable to load xID. Please try again.',
        defaultMessage: 'Unable to load {quoteID}. Please try again.'
    }
});
